var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, DateField, Grid, GridColumn, Heading, List, ListItem, Modal, ModalFooter, Notice, Selector, Separator, Text, TextField, Toggle, Tooltip, TooltipToggle } from 'telia-front-react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Spinner } from '../../config/common';
import { communicationLanguages, MandateQueryType } from '../../config/mandate';
import CountrySuggestionField from '../../country/CountrySuggestionField';
import { DEFAULT_VALID_UNTIL } from '../../stores/MandateStore';
import CountryUtil from '../../util/CountryUtil';
import SpinnerToggle from '../../util/SpinnerToggle';
import { injectStores } from '../../util/StoresUtil';
let RepresentationRightsAddMandateModal = class RepresentationRightsAddMandateModal extends Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "addMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personDataRegistryStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submitForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                const savingResult = await this.addMandateStore.submitCustomerMandate();
                if (savingResult) {
                    this.mandateStore.fetchMandates(MandateQueryType.CUSTOMER_MANDATES);
                    this.closeModal();
                }
            }
        });
        Object.defineProperty(this, "closeModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.addMandateStore.toggleModalOpen(false);
            }
        });
        Object.defineProperty(this, "changeField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, field) => {
                const { newCustomerMandate, isCustomer } = this.addMandateStore;
                if (field === 'personalCodeCountryCode' && !isCustomer) {
                    newCustomerMandate.communicationLanguageCode = null;
                }
                newCustomerMandate[field] = value;
            }
        });
        makeObservable(this);
    }
    render() {
        const { translate } = this.translateStore;
        const { resetCustomerMandate, mandateSaveError, personNotFound, isMandateForSelf, isUnderage } = this.addMandateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { text: translate('personPowers.addMandate'), id: "add-mandate", iconRight: "#file-edit", onClick: () => this.addMandateStore.toggleModalOpen(true) }),
            React.createElement(Modal, { size: "6-col", onClose: () => resetCustomerMandate(), isOpen: this.addMandateStore.isModalOpen },
                React.createElement(SpinnerToggle, { name: Spinner.ADD_MANDATE_MODAL }),
                React.createElement(Text, null,
                    React.createElement(Heading, { className: "h3" }, translate('personPowers.addMandateModal.title')),
                    mandateSaveError && this.renderMandateSaveErrorNotice(),
                    personNotFound && this.renderPersonNotFoundNotice(),
                    isMandateForSelf && this.renderMandateForSelfNotice(),
                    isUnderage && this.renderIsUnderageNotice(),
                    React.createElement(Heading, { level: 2, className: "h4 text-bold text__margin-double" }, translate('personPowers.addMandateModal.personData')),
                    this.renderPersonFields(),
                    React.createElement(Heading, { level: 2, className: "h4 text-bold text__margin-double" }, translate('personPowers.addMandateModal.mandateData')),
                    React.createElement(List, { type: "unstyled", bordered: true }, this.renderMandateTypeToggleOptions()),
                    this.renderValidUntil()),
                React.createElement(ModalFooter, null, this.renderFooter()))));
    }
    renderPersonFields() {
        const { translate } = this.translateStore;
        const { newCustomerMandate, fetchPersonDataWhenValid } = this.addMandateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['sm-9'] },
                    React.createElement(TextField, { id: "first-name", label: translate('personPowers.addMandateModal.firstName'), value: newCustomerMandate.firstName, onBlur: fetchPersonDataWhenValid, errorMessage: this.addMandateStore.validatePersonFields && !this.addMandateStore.newCustomerMandate.firstName
                            ? translate('personPowers.addMandate.error.firstName.mandatory')
                            : undefined, onChange: (value) => this.changeField(value, 'firstName') })),
                React.createElement(GridColumn, { width: ['sm-9'] },
                    React.createElement(TextField, { id: "last-name", label: translate('personPowers.addMandateModal.lastName'), value: newCustomerMandate.lastName, onBlur: fetchPersonDataWhenValid, errorMessage: this.addMandateStore.validatePersonFields && !this.addMandateStore.newCustomerMandate.lastName
                            ? translate('personPowers.addMandate.error.lastName.mandatory')
                            : undefined, onChange: (value) => this.changeField(value, 'lastName') }))),
            React.createElement(Separator, { spacing: "medium" }),
            React.createElement(Grid, { className: "text__margin-none" },
                React.createElement(GridColumn, { width: ['sm-7'] },
                    React.createElement(TextField, { id: "personalCode", label: translate('personPowers.addMandateModal.personalCode'), defaultValue: newCustomerMandate.personalCode, onChange: (value) => this.changeField(value, 'personalCode'), onBlur: fetchPersonDataWhenValid, errorMessage: this.personDataRegistryStore.personalCodeError
                            ? translate(`personPowers.addMandate.error.${this.personDataRegistryStore.personalCodeError}`)
                            : undefined, input: { maxLength: 25 } })),
                React.createElement(GridColumn, { width: ['sm-7'] },
                    React.createElement(CountrySuggestionField, { id: "personalCodeCountryCode", labelKey: "personPowers.addMandateModal.personalCodeCountryCode", country: CountryUtil.getByCountryCode(newCustomerMandate.personalCodeCountryCode), onChange: (country) => this.changeField(country && country.code, 'personalCodeCountryCode'), onSelect: fetchPersonDataWhenValid })),
                this.renderCommunicationLanguages()),
            React.createElement(Separator, { spacing: "medium" })));
    }
    renderCommunicationLanguages() {
        const { translate } = this.translateStore;
        const { newCustomerMandate, isCustomer } = this.addMandateStore;
        return !isCustomer ? (React.createElement(GridColumn, null,
            React.createElement(Selector, { id: "person-powers-add-mandate-modal-communication-language-code", className: "text__margin-double", size: "small", value: newCustomerMandate.communicationLanguageCode, items: this.getCommunicationLanguageOptions(), label: translate('personPowers.addMandateModal.communicationLanguageCode'), onChange: (value) => this.changeField(value, 'communicationLanguageCode') }))) : null;
    }
    renderValidUntil() {
        const { translate } = this.translateStore;
        const { validUntil, changeValidUntil } = this.addMandateStore;
        return (React.createElement(Grid, { className: "text__margin-double" },
            React.createElement(GridColumn, { width: ['sm-5', 'lg-6'] },
                React.createElement(DateField, { label: translate('personPowers.addMandateModal.validUntil'), id: "valid-until", defaultValue: validUntil, onChange: changeValidUntil, datepicker: {
                        clearButtonLabel: translate('personPowers.addMandateModal.datepicker.clear'),
                        submitButtonLabel: translate('personPowers.addMandateModal.datepicker.submit'),
                        range: { from: new Date(), to: DEFAULT_VALID_UNTIL },
                        onClear: changeValidUntil
                    }, helpMessage: translate('personPowers.addMandateModal.validUntil.notice'), errorMessage: !validUntil ? translate('personPowers.addMandateModal.validUntil.mandatory') : undefined }))));
    }
    renderFooter() {
        const { translate } = this.translateStore;
        const { canAddMandate } = this.addMandateStore;
        return (React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement(Button, { iconLeft: "#file-check-simple", disabled: !canAddMandate, text: translate('personPowers.addMandateModal.save'), onClick: this.submitForm })),
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement(Button, { text: translate('personPowers.addMandateModal.cancel'), link: true, onClick: this.closeModal }))));
    }
    renderMandateSaveErrorNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.addMandateModal.mandateSaveError')));
    }
    renderPersonNotFoundNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.addMandateModal.personNotFound')));
    }
    renderMandateForSelfNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.addMandateModal.mandateForSelfError')));
    }
    renderIsUnderageNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.addMandateModal.isUnderageError')));
    }
    renderMandateTypeToggleOptions() {
        const { translate } = this.translateStore;
        const { toggleMandateType, getMandateTypes, hasMandateType } = this.addMandateStore;
        return getMandateTypes().map((mandateType, index) => (React.createElement(ListItem, { key: index },
            React.createElement(Toggle, { id: `mandate-type-${mandateType}`, label: translate(`personPowers.mandate.type.${mandateType}`), onChange: () => toggleMandateType(mandateType), checked: hasMandateType(mandateType), children: React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, { id: `add-mandate-modal-${mandateType}` }, translate(`personPowers.mandate.type.${mandateType}`)) }, translate(`personPowers.mandate.type.${mandateType}-tooltip`)) }))));
    }
    getCommunicationLanguageOptions() {
        const { translate } = this.translateStore;
        const { isCustomer } = this.addMandateStore;
        return communicationLanguages.map((language) => ({
            id: `communication-language-${language}`,
            name: `communication-language-${language}`,
            value: language,
            label: translate(`language.${language}`),
            disabled: isCustomer
        }));
    }
};
__decorate([
    action.bound
], RepresentationRightsAddMandateModal.prototype, "changeField", void 0);
RepresentationRightsAddMandateModal = __decorate([
    injectStores,
    observer
], RepresentationRightsAddMandateModal);
export default RepresentationRightsAddMandateModal;
